/**
 * @desc -> iframe的数据通信
 * @asana https://app.asana.com/0/1201739123936511/1202417671438023
 */
// 所有的消息类型
export enum SessionMessageAction {
    get_parentUrl = 'get_parentUrl', // 获取父级窗口url
    go_back_directory = 'go_back_directory',// 返回课程目录页面
    go_previous_section = 'go_previous_section', // 进入上一章节
    go_next_section = 'go_next_section', // 进入下一章节
    openPage = 'openPage', // 打开页面
    triggerClick = 'triggerClick', // 触发点击
    navigationBarBehavior = 'navigationBarBehavior', // iframe自己有navigationBar
    needLogin = 'needLogin', // 需要登录
    syncLogin = 'syncLogin', // 同步页面被登录的信息
    syncSessionProgress = 'syncSessionProgress', // 同步小节的学习进度

    down_prev_course = 'down_prev_course', // 上一节课
    up_go_prev_course = 'down_prev_course', // 去上一节课
    down_next_course = 'down_next_course', // 下一节课
    up_go_next_course = 'down_next_course', // 去下一节课
    up_share_course = 'up_share_course', // 分享课程
    up_fold_parent_sidebar = 'up_fold_parent_sidebar', // 控制父页面的目录折叠
    block_go_other_session = 'block_go_other_session', // 阻止跳转到其他小节
    unblock_go_other_session = 'unblock_go_other_session', // 允许跳转到其他小节
}
// iframe数据的payload
export interface IIframeMessageData<A extends SessionMessageAction, T> {
    action: A;
    data: T;
};

// 父子首次通信，交换url信息 ----------
export interface IIframeACKParentModel {
    href: string;
    origin: string;
    pathname: string;
}
export interface IIframeACKChildModel {
    url: string;
}
export type IIframeACK<T> = IIframeMessageData<SessionMessageAction.get_parentUrl, T>;
export type IIframeACKParent = IIframeACK<IIframeACKParentModel>
export type IIframeACKChild = IIframeACK<IIframeACKChildModel>

// 父子小节类型的通信 -------------------
// 点击上一节
export interface ISessionClickPrevNextPayload {
    info: {
        data: {
            url: string,
            type: string,
        } & any;
    },
    from: string;
}
export type IIframeSessionClickPrevACK<T> = IIframeMessageData<SessionMessageAction.go_previous_section, T>;
export type IIframeSessionClickPrevACKChild = IIframeSessionClickPrevACK<ISessionClickPrevNextPayload>;
// 点击下一节
export type IIframeSessionClickNextACK<T> = IIframeMessageData<SessionMessageAction.go_next_section, T>;
export type IIframeSessionClickNextACKChild = IIframeSessionClickNextACK<ISessionClickPrevNextPayload>;
// -------------------

export enum CourseShareTypes {
    shareCard,
    shareToClass
}

// 点击分享/复制链接/分享到班级等
export enum SessionTriggerClickTypes {
    shareCard,
    shareToClass,
    copyLink,
    favor, // 收藏
    unFavor, // 取消收藏
}
export interface ISessionTriggerClickPayload {
    clickType: SessionTriggerClickTypes;
    sessionId: string;
}
export type IIframeSessionTriggerClickACK<T> = IIframeMessageData<SessionMessageAction.triggerClick, T>;
export type IIframeSessionTriggerClickACKChild = IIframeSessionTriggerClickACK<ISessionTriggerClickPayload>;
// -------------------

// 导航栏的行为
export enum NavigationBarBehaviorType {
    leftHidden,
    leftBack,
    rightHidden,
    leftRightHidden,
}
export interface IMessageActionNavigationBarPayload {
    url: string;
    type: NavigationBarBehaviorType;
}
export type IIframeSessionNavigationACK<T> = IIframeMessageData<SessionMessageAction.navigationBarBehavior, T>;
export type IIframeSessionNavigationACKChild = IIframeSessionNavigationACK<IMessageActionNavigationBarPayload>;
// -------------------

// 需要登录
export interface IMessageActionNeedLoginPayload {
    url: string;
}
export type IIframeNeedLoginACK<T> = IIframeMessageData<SessionMessageAction.needLogin, T>;
export type IIframeNeedLoginACKChild = IIframeNeedLoginACK<IMessageActionNeedLoginPayload>;

// -------------------

// iframe中的登录同步到parent，刷新
export interface IMessageActionSyncLoginPayload {
    url: string;
}
export type IIframeSyncLoginACK<T> = IIframeMessageData<SessionMessageAction.syncLogin, T>;
export type IIframeSyncLoginACKChild = IIframeSyncLoginACK<IMessageActionSyncLoginPayload>;

// -------------------

// iframe中小节学习进度同步到外层，刷新
export enum IMessageSessionProgressEnum {
    progress = 'progress',
    finished = 'finished',
}
export interface IMessageActionSyncSessionProgressPayload {
    sessionId: string;
    progress?: IMessageSessionProgressEnum;
}
export type IIframeSyncSessionProgressACK<T> = IIframeMessageData<SessionMessageAction.syncSessionProgress, T>;
export type IIframeSyncSessionProgressACKChild = IIframeSyncLoginACK<IMessageActionSyncSessionProgressPayload>;
